// Logic.js (useAuth.js)

import { useState } from "react";
import { loginAdmin as loginApi } from "./Service";
import { useAdminAuth } from "../../../ContextAPI/AdminContex";

export default function useAuth() {
  const { loginAdmin } = useAdminAuth(); // from context

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  // ------------------------------
  // VALIDATION
  // ------------------------------
  const validate = () => {
    let valid = true;

    if (!email.includes("@") || !email.includes(".")) {
      setEmailError("Please enter a valid email address.");
      valid = false;
    } else {
      setEmailError("");
    }

    if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters.");
      valid = false;
    } else {
      setPasswordError("");
    }

    return valid;
  };

  // ------------------------------
  // HANDLE LOGIN
  // ------------------------------
  const handleLogin = async () => {
    setApiError("");
    setEmailError("");
    setPasswordError("");

    if (!validate()) return;

    try {
      setLoading(true);

      const data = await loginApi(email, password);

      // store token using context
      loginAdmin(data.access_token);

      // redirect
      window.location.href = "/dashboard";

    } catch (err) {
      const errorMsg =
        err?.response?.data?.detail ||
        err?.detail ||
        "Login failed";

      console.log("LOGIN ERROR:", errorMsg);

      if (errorMsg === "Email not found") {
        setEmailError("Email not found.");
      } else if (
        errorMsg === "Wrong password" ||
        errorMsg === "Incorrect password." ||
        errorMsg.toLowerCase().includes("password")
      ) {
        setPasswordError("Incorrect password.");
      } else {
        setApiError(errorMsg);
      }

    } finally {
      setLoading(false);
    }
  };

  const isValid = email.length > 0 && password.length > 0;

  return {
    email,
    setEmail,
    password,
    setPassword,
    emailError,
    passwordError,
    apiError,
    handleLogin,
    isValid,
    loading,
  };
}
